import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getWorkInformation = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PROFESSIONAL.GET_WORK_INFORMATION,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}